import React from 'react';
import PropTypes from 'prop-types';
import MaintenanceState from '@adsk/acc-maintenance-state';
import ConnectedTopNavigationOptionalUser from './ConnectedTopNavigationOptionalUser';
import NavigationLayout from './NavigationLayout';
const MaintenancePage = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    onLogout,
    endDate
  } = _ref;
  return /*#__PURE__*/React.createElement(NavigationLayout, {
    ref: ref,
    renderSideNavigation: () => null,
    renderTopNavigation: () => /*#__PURE__*/React.createElement(ConnectedTopNavigationOptionalUser, {
      onLogout: onLogout
    })
  }, /*#__PURE__*/React.createElement(MaintenanceState, {
    endDate: endDate
  }));
});
MaintenancePage.displayName = 'MaintenancePage';
MaintenancePage.propTypes = {
  /** callback called on logout */
  onLogout: PropTypes.func,
  /** The end date to show the maintenance page for */
  endDate: PropTypes.instanceOf(Date)
};
export default MaintenancePage;
//# sourceMappingURL=MaintenancePage.js.map